"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "appendApptInfoToBookingUrl", {
  enumerable: true,
  get: function () {
    return _providerComponents.appendApptInfoToBookingUrl;
  }
});
exports.getAvailTilesBookingUrlForPlacement = getAvailTilesBookingUrlForPlacement;
var _providerComponents = require("@kyruus/provider-components");
var _availabilityTiles = require("@kyruus/availability-tiles");
var _tracking = require("./constants/tracking");
var _url = require("./url");
/**
 * Based on placement, return modified bookOnlineUrl with tracking params appended
 * @param {String} bookOnlineUrl
 * @param {String} placementType see constants/tracking for placement types
 * @returns
 */
function getAvailTilesBookingUrlForPlacement(bookOnlineUrl, placementType) {
  if (!bookOnlineUrl) {
    return bookOnlineUrl;
  }
  if (placementType === _tracking.PLACEMENT_TYPE_PROFILE) {
    return (0, _url.withQueryParam)(bookOnlineUrl, _tracking.BOOK_TRACKING_PARAM_NAME, _availabilityTiles.availabilityTilesTracking.TRACKING_SOURCE_PROFILE);
  } else if (placementType === _tracking.PLACEMENT_TYPE_SEARCH) {
    return (0, _url.withQueryParam)(bookOnlineUrl, _tracking.BOOK_TRACKING_PARAM_NAME, _availabilityTiles.availabilityTilesTracking.TRACKING_SOURCE_SEARCH);
  }
  return bookOnlineUrl;
}